import EventDispatcherModule from '@shcc/modules/EventDispatcherModule';
import TrottlerModule from '@shcc/modules/TrottlerModule';

const SCROLL_INTERVAL = 250;

export const SCROLL_DIRECTION = {
  up: 'Scroll/Direction/Up',
  down: 'Scroll/Direction/Down',
};

class ScrollModule extends EventDispatcherModule {
  constructor() {
    super();

    // Bind handlers
    this._scrollHandler = this._scrollHandler.bind(this);
    this._trottlerCompleteHandler = this._trottlerCompleteHandler.bind(this);

    this._setPosition();
    this._setPreviousPosition();
    this._setDirection();
    this._setupTrottler();
    this._setupEventListeners();
  }

  _setupTrottler() {
    this._trottler = new TrottlerModule({ delay: SCROLL_INTERVAL });
  }

  _setupEventListeners() {
    if (typeof window !== `undefined`) {
      window.addEventListener('scroll', this._scrollHandler, { passive: true });
    }
  }

  // prettier-ignore
  _setDirection() {
    if (this.position.y === this.previous.y) return; // Don't do anything if same

    const direction = this.position.y > this.previous.y ? SCROLL_DIRECTION.down : SCROLL_DIRECTION.up;
    
    if (direction !== this.direction) {
      this.direction = direction;
      
      this.dispatchEvent('change:direction', this.direction);
    }
  }

  _setPosition() {
    this.position = this._getScrollPosition();
  }

  _setPreviousPosition() {
    this.previous = this.position;
  }

  _getScrollPosition() {
    let x = 0;
    let y = 0;

    if (typeof window !== `undefined`) {
      x = window.pageXOffset || document.documentElement.scrollLeft;
      y = window.pageYOffset || document.documentElement.scrollTop;
    }

    return { x, y };
  }

  _getEventPayload() {
    return {
      context: this,
      ...this.position,
    };
  }

  _scrollHandler() {
    this._setPosition();
    this._setDirection();
    this._setPreviousPosition();

    this._trottler.clear();
    this._trottler.start(this._trottlerCompleteHandler);

    this.dispatchEvent('scroll', this._getEventPayload());
  }

  _trottlerCompleteHandler() {
    this._setPosition();
    this._setDirection();
    this._setPreviousPosition();

    this.dispatchEvent('scroll:end', this._getEventPayload());
  }
}

export default ScrollModule;
export const scrollModule = new ScrollModule();
